/**
 * @file Account related queries.
 */
import gql from 'graphql-tag';

import { UserDetails } from '../fragments/account';
import { IdentityDetails } from '../fragments/identity';

export const MeWithIdentities = gql`
  query meWithIdentities {
    me {
      ...UserDetails
      linked_identities(relation: ALL) {
        records {
          ...IdentityDetails
          selected_identities(slice: { limit: 1 }) {
            records {
              id
              album_membership {
                id
                album {
                  id
                  name
                  subscription_album_folder {
                    id
                    name
                    join_type
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  ${UserDetails}
  ${IdentityDetails}
`;
